import { useEffect } from 'react';

export function usePageTitle(title: string) {
    useEffect(() => {
        const appName = 'MoreZero Admin';
        document.title = title ? `${title} - ${appName}` : appName;
    }, [title]);
}
